import React from "react";
import ActionArgs from "./action_args";
import {
  WorkflowTask,
  ActionDefinition,
  TaskArgument,
} from "common/flowmaster/types/task_config";
import {
  WorkflowContext,
  WorkflowInputs,
  Prompt,
  Workflow,
} from "common/flowmaster/types/workflow";
import {OrganisationId} from "common/types/organisation";
import {Topic} from "common/types/topic";

interface ActionArgumentProps {
  argDefinition: {
    key: string;
    label: string;
    type: string;
  };
  argValue: TaskArgument;
  index: number;
  onUpdateItem: (value: TaskArgument) => void;
  priorTasks: WorkflowTask[];
  futureTasks: WorkflowTask[];
  context: WorkflowContext;
  inputs: WorkflowInputs;
  prompts: Prompt[];
  actionDefinitions: ActionDefinition[];
  workflows: Workflow[];
  organisationId: OrganisationId;
  embeddingTopics: Topic[];
  handleHasError: (hasError: boolean) => void;
  disabled?: boolean;
  useListItem?: boolean;
}

const ActionArgument: React.FC<ActionArgumentProps> = ({
  argDefinition,
  argValue,
  index,
  onUpdateItem,
  priorTasks,
  futureTasks,
  context,
  inputs,
  prompts,
  actionDefinitions,
  workflows,
  organisationId,
  embeddingTopics,
  handleHasError,
  disabled,
  useListItem = false,
}) => {
  const {Component} = ActionArgs[argDefinition.type];

  return (
    <div style={{display: "flex", flexDirection: "row", width: "100%"}}>
      <div
        style={{
          marginRight: "1em",
          flexShrink: 0,
          minWidth: "8em",
          marginTop: "1em",
          fontVariant: "small-caps",
        }}
      >
        {argDefinition.label}
      </div>
      <div style={{width: "100%"}}>
        {Component ? (
          <Component
            key={`${argDefinition.key}_${index}`}
            {...{
              argDefinition,
              argValue,
              onUpdateItem,
              priorTasks,
              futureTasks,
              context,
              inputs,
              prompts,
              actionDefinitions,
              workflows,
              organisationId,
              embeddingTopics,
              handleHasError,
              disabled,
              useListItem,
            }}
          />
        ) : null}
      </div>
    </div>
  );
};

export default ActionArgument;
